// smoothScroll
jQuery.easing.quart = function (x, t, b, c, d) {
  return -c * ((t=t/d-1)*t*t*t - 1) + b;
};

jQuery(document).ready(function(){
  jQuery('a[href*="#"]').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name=' + this.hash.slice(1) +']');
      if ($target.length) {
        var targetOffset = $target.offset().top;
        jQuery('html,body').animate({ scrollTop: targetOffset }, 1200, 'quart');
        return false;
      }
    }
  });
});


// slide btn
$(function(){
  let winscrW = window.innerWidth; //スクロールバーを含む幅 

  $('.js-slide_btn').each(function(index, element) {
    //PCレイアウト時は、最初から開いた状態にする
    $(element).click(function(){
      $(this).toggleClass('on');
      $(element).next('.js-slide_panel').slideToggle(300);
    });
  });

  // ハッシュがあるときはオープン
  if(window.location.hash.length > 0){
    $(window.location.hash).toggleClass('on').next('.js-slide_panel').toggle();
  }
});

$(window).on('load resize', function () {
  $('.js-slide_btn').each(function(index, element) {
    if ( $(this).next('.js-slide_panel').css('display') == 'block' ) {
      $(this).addClass('on');
      $(this).next('.js-slide_panel').removeClass('js-loadinit');
    }
  });
});


//button animation
$(function(){
  document.querySelectorAll('.js-anime-btn').forEach(btntxt => {
    let div = document.createElement('div'),
      letters = btntxt.textContent.trim().split('');
  
    function elements(letter, index, array) {
      let element = document.createElement('span'),
          part = (index >= array.length / 2) ? -1 : 1,
          position = (index >= array.length / 2) ? array.length / 2 - index + (array.length / 2 - 1) : index,
          move = position / (array.length / 2),
          rotate = 1 - move;
  
      element.innerHTML = !letter.trim() ? '&nbsp;' : letter;
      element.style.setProperty('--move', move);
      element.style.setProperty('--rotate', rotate);
      element.style.setProperty('--part', part);
  
      div.appendChild(element);
    }
  
    letters.forEach(elements);
  
    btntxt.innerHTML = div.outerHTML;
  
    btntxt.addEventListener('mouseenter', e => {
      if(!btntxt.classList.contains('out')) {
        btntxt.classList.add('in');
      }
    });
  
    btntxt.addEventListener('mouseleave', e => {
      if(btntxt.classList.contains('in')) {
        btntxt.classList.add('out');
        setTimeout(() => btntxt.classList.remove('in', 'out'), 950);
      }
    });
  });
});


//ハンガー
$(window).on('load scroll resize', function () {
  var winscrW = window.innerWidth; //スクロールバーを含む幅 
  var winH = $(window).height(); //ウィンドウの高さ

  var scroll = $(window).scrollTop();
  var swingitem = $('.js-swingitem');

  swingitem.each(function () {
    var siTop = $(this).offset().top; // 要素が画面の上から95%(下から5%)に来た時に動く

    var swingitemPos = siTop - winH * 0.95;

    if (scroll > swingitemPos) {
      $(this).addClass("js-anime-swing");
    }
  }); //要素フェードイン&アップ
});
